import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
function CanAccess(props) {
  const { perform, yes, no } = props;
  const permissions = useSelector(
    (state) => state.currentUserState.permissions
  );
  const [hasValidPermission, setHasValidPermission] = useState(false);

  useEffect(() => {
    console.log("permissions:", permissions);
    console.log("perform:", perform);
    if (perform)
      for (let i = 0; i < permissions.length; i++) {
        if (permissions[i].authority === perform) {
          return setHasValidPermission(true);
        }
      }
    return setHasValidPermission(false);
  }, [perform, permissions]);

  if (!perform) return yes();

  return hasValidPermission ? yes() : no();
}

CanAccess.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default CanAccess;